import React from 'react'
import MetaTags from "react-meta-tags";

const CodeTags = (props) => {
    let title = `Введите код доступа к камерам видеонаблюдения | Мой Дом Ситилинк`;
    let canonical = "https://moidom.citylink.pro/code";

    return (
        <MetaTags>
            <title>{title}</title>
            <meta name="description"
                  content="Введите код доступа, чтобы посмотреть записи с дворовых камер наблюдения. Смотрите онлайн и скачивайте видео с архива."/>
            <meta property="og:title" content="Мой Дом"/>
            <link rel="canonical" href={canonical} />
        </MetaTags>
    )
}

export default CodeTags;